export const CLOSE_ICON = 'https://www.materialui.co/materialIcons/navigation/cancel_black_192x192.png'

export const standard_cost_price_table = [
  { label: 'Level', value: 0 },
  { label: 'Start Date', value: 1 },
  { label: 'End Date', value: 2 },
  { label: 'Std. Cost', value: 3 },
  { label: 'Std. Price', value: 4 },
  { label: 'Weighted MD', value: 5 },
  { label: 'SGA (WMD)', value: 6 },
  { label: 'SGA Support (MD)', value: 7 },
]
export const levels = [
  { label: 'Junior', value: 'Junior' },
  { label: 'Consultant', value: 'Consultant' },
  { label: 'Senior Consultant', value: 'Senior Consultant' },
  { label: 'Manager', value: 'Manager' },
  { label: 'Asst. VP', value: 'Asst. VP' },
  { label: 'VP', value: 'VP' },
  { label: 'Director', value: 'Director' },
  { label: 'BOS', value: 'BOS' },
]



// WEBPACK FOOTER //
// ./src/components/standard-cost-price/constants.js